(function () {
  const notification = document.querySelector('[data-thw-purchase-notification]');
  const dataElement = document.querySelector('[data-thw-purchase-notification-data]');

  if (!notification || !dataElement) return;

  let entries;
  const excludedProducts = new Set([
    '2018 Renault Koleos Rear Brake Caliper',
    '2016 Mitsubishi Outlander DPF Sensor',
    'Mazda CX-9 Centre Console Switch',
    'Mitsubishi Triton Fog Light',
    'Mazda CX-5 KF Front Bumper',
    'Toyota Corolla Hatch Tail Light',
    'Hyundai i30 Front Bumper',
  ]);

  try {
    entries = JSON.parse(dataElement.textContent).filter(
      (entry) => entry.product && entry.location && !excludedProducts.has(entry.product)
    );
  } catch (error) {
    return;
  }

  if (!entries.length) return;

  const message = notification.querySelector('[data-thw-purchase-notification-message]');
  const time = notification.querySelector('[data-thw-purchase-notification-time]');
  const price = notification.querySelector('[data-thw-purchase-notification-price]');
  const view = notification.querySelector('[data-thw-purchase-notification-view]');
  const image = notification.querySelector('[data-thw-purchase-notification-image]');
  const close = notification.querySelector('[data-thw-purchase-notification-close]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const visibleDuration = 10000;
  const pauseDuration = 45000;
  let currentIndex = Math.floor(Math.random() * entries.length);
  let hideTimer;
  let nextTimer;

  const scheduleNext = () => {
    window.clearTimeout(nextTimer);
    nextTimer = window.setTimeout(() => {
      currentIndex = (currentIndex + 1) % entries.length;
      showEntry(entries[currentIndex]);
    }, pauseDuration);
  };

  const showEntry = (entry) => {
    message.textContent = entry.product;
    message.href = entry.url || '#';
    time.textContent = `Popular in ${entry.location}`;
    if (price) {
      price.textContent = '';
      price.hidden = true;
    }
    if (view) view.href = entry.url || '#';
    if (image) {
      image.hidden = true;
      image.removeAttribute('src');
      image.alt = entry.product;
    }
    notification.classList.remove('is-visible');
    window.requestAnimationFrame(() => {
      notification.classList.add('is-visible');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => {
        notification.classList.remove('is-visible');
        scheduleNext();
      }, visibleDuration);
    });

    if (image && entry.url) {
      fetch(`${entry.url}.js`)
        .then((response) => (response.ok ? response.json() : null))
        .then((product) => {
          const imageUrl = product?.images?.[0];
          if (!imageUrl) return;
          image.src = imageUrl;
          image.hidden = false;
          if (price && Number.isFinite(product.price)) {
            price.textContent = new Intl.NumberFormat('en-AU', {
              style: 'currency',
              currency: 'AUD',
            }).format(product.price / 100);
            price.hidden = false;
          }
        })
        .catch(() => {});
    }
  };

  close?.addEventListener('click', () => {
    window.clearTimeout(hideTimer);
    notification.classList.remove('is-visible');
    scheduleNext();
  });

  window.setTimeout(() => {
    showEntry(entries[currentIndex]);
  }, reducedMotion ? 1000 : 3500);
})();
